import * as React from 'react';

import ShareActivityModal from './share_modal';

import { redirectToActivity, safeParseHtml, SMALL_ICON_BASE_SRC, UNIT_TEMPLATE_NAME } from '../../../Shared/index';
import { requestPost, } from '../../../../modules/request';


const userIconSrc = `${SMALL_ICON_BASE_SRC}/account.svg`;
const bookOpenIconSrc = `${SMALL_ICON_BASE_SRC}/teacher.svg`;

interface AnonymousPartnerLandingProps {
  activityId: number;
  activityDescription: string;
  activityTitle: string;
  partner: string;
  sharableLink?: string;
}

const AnonymousPartnerLanding: React.FC<AnonymousPartnerLandingProps> = ({
  activityDescription,
  activityId,
  activityTitle,
  partner,
  sharableLink,
}) => {
  const [showShareModal, setShowShareModal] = React.useState(false);

  function handleAssignLink() {
    window.localStorage.setItem(UNIT_TEMPLATE_NAME, activityTitle)
    requestPost(
      '/session/set_post_auth_redirect',
      { post_auth_redirect: `/assign/activity-library?search=${activityTitle}` },
      () => window.location.href = '/session/new'
    );

  }

  function handleCopyLink() {
    setShowShareModal(true);
  };

  function closeShareModal() {
    setShowShareModal(false);
  };

  function handlePreviewActivity() {
    redirectToActivity(activityId, true);
  };

  function handleStartActivity() {
    requestPost(
      `/partner/${partner}/activity_session/${activityId}`,
      {},
      (body) => {
        window.location.href = `${body.redirect_url.path}?${body.redirect_url.query}`
      }
    );
  };

  const activityPackData = {
    name: activityTitle,
    activityCount: 1,
    activities: []
  };

  return (
    <main>
      {showShareModal && (
        <ShareActivityModal
          closeModal={closeShareModal}
          link={window.location.href}
          title={activityTitle}
        />
      )}
      <div className="anonymous-partner-landing-container">
        <div className="content-wrapper">
          <header className="landing-header">
            <h1>{safeParseHtml(activityTitle)}</h1>
            <p className="activity-description">
              {safeParseHtml(activityDescription)}
            </p>
          </header>

          <section className="for-students-section">
            <div className="section-header">
              <img alt="" src={userIconSrc} />
              <h2>For Students</h2>
            </div>
            <div className="action-row">
              <h3>Complete Activity</h3>
              <div className="action-content">
                <p>You will be able to play through the activity anonymously without needing an account.</p>
              </div>
              <button
                className="quill-button contained medium green focus-on-light"
                onClick={handleStartActivity}
                type="button"
              >
                Start Activity Now
              </button>
            </div>
          </section>

          <section className="for-teachers-section">
            <div className="section-header">
              <img alt="" src={bookOpenIconSrc} />
              <h2>For Teachers</h2>
            </div>

            <div className="action-row">
              <h3>Preview Activity</h3>
              <div className="action-content">
                <p>Try the activity yourself before sharing this link with students or assigning it from your Quill account.</p>
              </div>
              <button
                className="quill-button outlined medium teal focus-on-light"
                onClick={handlePreviewActivity}
                type="button"
              >
                Start Teacher Preview
              </button>
            </div>

            <div className="action-row">
              <h3>Share Activity Link</h3>
              <div className="action-content">
                <p>Provide a link to students to complete the activity anonymously without needing an account. Students practice writing, but the results are not saved or shared.</p>
              </div>
              <button
                className="quill-button outlined medium teal focus-on-light"
                onClick={handleCopyLink}
                type="button"
              >
                Copy Sharing Link
              </button>
            </div>

            <div className="action-row">
              <h3>Assign to Students</h3>
              <div className="action-content">
                <p>After signing in to Quill, you can assign this activity from your teacher account. Students sign in to complete the activity, and you view results in your dashboard.</p>
              </div>
              <button
                className="quill-button outlined medium teal focus-on-light"
                onClick={handleAssignLink}
                type="button"
              >
                Assign Activity in Quill
              </button>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default AnonymousPartnerLanding;
